const darkMode = state => state.darkMode;
const name = state => state.name;
const list = state => state.list;

export default {
  darkMode,
  name,
  list,
};
